import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css } from 'styled-components'

interface ObjectTableProps {
  className?: string
}

const ObjectTable: React.FC<React.PropsWithChildren<ObjectTableProps>> = (
  props,
): React.ReactElement => {
  return (
    <div
      className={props.className}
      css={css`
        width: 100%;
        display: table;
        table-layout: fixed;
        background-color: ${styleConstants.colors.gray_lightest};
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
      `}
    >
      {props.children}
    </div>
  )
}

export default ObjectTable
